import React from 'react';
import { BotIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="final-title" data-id="element-59" data-mp="15ddjbc9f61kl">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-60" data-mp="15fq9udt8tk99">
        <h2 id="final-title" className="text-balance font-display text-4xl font-extrabold uppercase tracking-tight text-foreground sm:text-5xl" data-id="element-61" data-mp="1jbtyzsp9f2ev">
          <span className="inline-flex items-center gap-2" data-id="element-62" data-mp="1t2ydysexqn9p">
            <BotIcon className="h-8 w-8 shrink-0 text-electric" aria-hidden="true" data-id="element-63" data-mp="1t2evnaldhwv5" /> {productBrand}
          </span>
          <span className="mx-auto mt-3 block w-fit rounded-lg bg-gold px-4 py-1 text-xl font-extrabold uppercase tracking-[.16em] text-background sm:text-2xl" data-id="element-64" data-mp="1o4n0m7pflumq">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-muted" data-id="element-65" data-mp="1x2p2epgzorb2">
          Created by industrial automation and control systems technical specialists, for professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-66" data-mp="x3sa4pclhk9d">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-muted" data-id="element-67" data-mp="120sg709g2n0h">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-68" data-mp="1b31lnbpuvq70">
              <CheckIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-69" data-mp="1b173g55yyc6m" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}